import React from 'react';
import { makeStyles } from 'design-system/styles';
import SectionTitleComponent from 'corp/components/UI/SectionTitle';
import QMWorkflowSidebar from '../QMWorkflow/QMWorkflowSidebar';

const QMSelectProjectPage: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.pageWrapper}>
      <div className={classes.sidebar}>
        <QMWorkflowSidebar />
      </div>
      <div className={classes.section}>
        <SectionTitleComponent title={'Select a project'} />
        <p>Please select a project from the left sidebar.</p>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  pageWrapper: {
    display: 'flex',
    'flex-direction': 'row',
    width: '100%',
    height: '100%',
  },
  sidebar: {
    marginTop: 24,
    minWidth: 300,
    float: 'left',
  },
  section: {
    marginTop: '50px',
    marginBottom: '30px',
    flexGrow: 2,
  },
});

export default QMSelectProjectPage;
